import { isNotEmpty, toSportUrlCase } from 'utility/functions';
import { useAvvenimento, useCompetitor, usePlayerData } from 'features/sport/hooks';

import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import classNames from 'classnames';
import { selectSelectedAvvenimento } from 'features/sport/selectors';
import styles from './SportMarcatoriTableRowMarcatore.module.scss';
import { useTranslation } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';

export type SportMarcatoriTableRowMarcatoreProps = {
  containerClassname?: string;
  playerKey: string;
};

export const SportMarcatoriTableRowMarcatore = ({
  containerClassname,
  playerKey,
}: SportMarcatoriTableRowMarcatoreProps) => {
  const { t } = useTranslation();
  const { avvenimentoKey, competitor } = useTypedSelector(selectSelectedAvvenimento) ?? {};
  const competitorTeam = useCompetitor(avvenimentoKey ?? '', competitor ?? 1);
  const { firstCompetitor, secondCompetitor } = useAvvenimento(avvenimentoKey);
  const player = usePlayerData(playerKey);

  const competitorDescriptions = [
    t(firstCompetitor?.descrizioneTrKey, firstCompetitor?.descrizione),
    t(secondCompetitor?.descrizioneTrKey, secondCompetitor?.descrizione),
  ];

  if (!competitorTeam || !playerKey) return;

  return (
    <AnchorLink href={toSportUrlCase(player.slug)} className={classNames(styles.container, containerClassname)}>
      <ul className={styles.list}>
        <li>
          {competitorDescriptions[0]} <span className={styles.divider}>-</span> {competitorDescriptions[1]}
        </li>
        <li>
          {isNotEmpty(competitorTeam?.iconSrc) && (
            <span className={styles.imageContainer}>
              <DynamicImage
                alt={t(competitorTeam?.descrizioneTrKey, competitorTeam?.descrizione) ?? ''}
                src={`${competitorTeam?.iconSrc}`}
                fill
                loading={enLoading.lazy}
                decoding="async"
              />
            </span>
          )}
          {player.valore}
        </li>
      </ul>
    </AnchorLink>
  );
};
